import React from 'react';
import { Notification } from 'wix-style-react';
function StandaloneNotification(_a) {
    var message = _a.message, _b = _a.type, type = _b === void 0 ? 'success' : _b;
    return (React.createElement(Notification, { show: true, type: "sticky", theme: type.toLowerCase(), autoHideTimeout: 5000 },
        React.createElement(Notification.TextLabel, null, message),
        React.createElement(Notification.CloseButton, null)));
}
export { StandaloneNotification };
//# sourceMappingURL=standalone-notification.js.map